import React from 'react';

import DataTable from '../shared/data_table';
import StatusPill from '../shared/status_pill';
import WhyPopover from '../overview/why_popover';

/*
 * PROD-7828 R8 — saved entries. Every affordance comes from the server's editable.actions; when a row
 * has none the reason (closed month, removed row, system entry) is shown instead of a disabled button,
 * so an operator is never left guessing why an entry cannot be touched.
 */
// highlight_uuid: the entry an IDEMPOTENCY_MISMATCH says was already saved — the operator lands on it.
const EntriesTable = ({ rows, on_edit, on_remove, highlight_uuid }) => {
  const actions_cell = (r) => {
    if (r.can_edit || r.can_remove || r.can_waive) {
      return (
        <span className="tp-actions">
          {r.can_edit ? (
            <button type="button" className="tp-link" onClick={() => on_edit(r)}>
              Edit
            </button>
          ) : null}
          {r.can_remove ? (
            <button type="button" className="tp-link" onClick={() => on_remove(r)}>
              Remove
            </button>
          ) : null}
          {r.can_waive ? (
            <button type="button" className="tp-link" onClick={() => on_remove(r)}>
              Waive
            </button>
          ) : null}
        </span>
      );
    }
    return (
      <span className="tp-card-field-label" title={r.why_not}>
        {r.why_not || 'Not editable'}
      </span>
    );
  };

  const columns = [
    { key: 'teacher_name', label: 'Teacher', hideInCard: true },
    { key: 'month_text', label: 'Month' },
    {
      key: 'category_label',
      label: 'Category',
      render: (r) => (
        <span>
          {r.category_label}
          {r.is_system && r.source_month_text ? (
            <span className="tp-card-field-label"> from {r.source_month_text}</span>
          ) : null}
        </span>
      )
    },
    { key: 'entry_type_label', label: 'Type' },
    {
      key: 'amount_text',
      label: 'Amount',
      align: 'right',
      render: (r) => (
        <WhyPopover
          detail={r.explain}
          amount_node={<span className={r.amount_tone}>{r.amount_text}</span>}
        />
      )
    },
    { key: 'entry_at_text', label: 'Date / time (IST)' },
    { key: 'note', label: 'Note', render: (r) => <span title={r.note}>{r.note || '—'}</span> },
    { key: 'reference_id', label: 'Ref', render: (r) => r.reference_id || '—' },
    {
      key: 'source_label',
      label: 'Source',
      render: (r) => <StatusPill tone={r.is_system ? 'blue' : 'gray'}>{r.source_label}</StatusPill>
    },
    {
      key: 'added_text',
      label: 'Added by / at',
      render: (r) => <span title={r.added_by_title}>{r.added_text}</span>
    },
    {
      key: 'status',
      label: 'Status',
      render: (r) => (
        <span>
          <StatusPill tone={r.is_removed ? 'red' : 'green'}>{r.status_label}</StatusPill>
          {r.reversed_text ? <div className="tp-card-field-label">{r.reversed_text}</div> : null}
          {r.is_removed && !r.reversed_text && r.removed_at_text ? (
            <div className="tp-card-field-label" title={r.remove_reason}>
              Removed by <span title={r.removed_by_title}>{r.removed_by_text}</span> ·{' '}
              {r.removed_at_text}
            </div>
          ) : null}
        </span>
      )
    },
    { key: 'actions', label: 'Actions', hideInCard: true, render: actions_cell }
  ];

  return (
    <DataTable
      columns={columns}
      rows={rows}
      rowKey={(r) => r.key}
      rowClassName={(r) => (highlight_uuid && r.uuid === highlight_uuid ? 'tp-row-hl' : '')}
      emptyText="No additional payments for this month and filter."
      cardTitle={(r) => (
        <span>
          {r.teacher_name}
          <span className={`${r.amount_tone} tp-card-amt`}>{r.amount_text}</span>
          {r.is_removed ? <StatusPill tone="red">{r.status_label}</StatusPill> : null}
          {actions_cell(r)}
        </span>
      )}
    />
  );
};

export default EntriesTable;
